import { Tab as T, TabProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const BannerTab = styled(T)<TabProps>(({ theme }) => ({
  textTransform: 'none',
  maxWidth: 'none',
  flex: '0 0 auto',
  color: 'inherit',
  textAlign: 'left',
  padding: '0.75rem 1.5rem',
  borderBottom: '3px solid transparent',
  '&:hover': {
    color: theme.palette.primary.main,
  },
  '&.Mui-selected': {
    fontWeight: 400,
    color: theme.palette.primary.main,
    borderBottom: `3px solid ${theme.palette.primary.main}`,
  },
}));

export default BannerTab;
